<script lang="ts">
    import { getContext } from 'svelte'
    import { derived as sderived } from 'svelte/store'
    import type { Readable, Writable } from 'svelte/store'

    import type { GenOrder } from '../order'

    import { gettext as _ } from 'hydria/services/gettext'
    import { notify } from 'hydria/services/notifications'
    import { simpleFetch } from 'hydria/services/session'
    import type { SimpleFetchResult } from 'hydria/services/session'

    const orderId = getContext('orderId') as Readable<string>
    const Order = getContext('Order') as GenOrder
    const order = sderived(Order.orderStore, ($order) => $order)

    interface Props {
        // const selectedItems: Writable<Set<string>> = getContext('selectedCartItems')
        selectedItems: Writable<Set<string>>
    }

    let { selectedItems }: Props = $props()

    const items = sderived(Order.items, ($items) => $items)

    const allSelected = sderived([items, selectedItems], ([$items, $selectedItems]) => {
        return $items.length == $selectedItems.size && $items.every((item) => $selectedItems.has(item.id))
    })
    const noneSelected = sderived(selectedItems, ($selectedItems) => {
        return $selectedItems.size == 0
    })
    const domainsAndRenewals = sderived(items, ($items) => {
        return $items.filter((item) => item.type == 'DOMAIN' || item.type == 'RENEWAL')
    })
    const allDomainsSelected = sderived([domainsAndRenewals, selectedItems], ([$items, $selectedItems]) => {
        return $items.every((item) => $selectedItems.has(item.id))
    })
    const onlyDomainsSelected = sderived([items, selectedItems], ([$items, $selectedItems]) => {
        for (const item of $items) {
            if (!$selectedItems.has(item.id)) continue
            if (item.type != 'DOMAIN' && item.type != 'RENEWAL') return false
        }
        return true
    })

    function deselectAll() {
        selectedItems.update((v) => {
            v.clear()
            return v
        })
    }
    function selectAll() {
        selectedItems.update((v) => {
            return new Set($items.map((item) => item.id))
        })
    }
    function selectAllDomains() {
        selectedItems.update((v) => {
            return new Set([...v, ...$items.filter((item) => item.type == 'DOMAIN' || item.type == 'RENEWAL').map((item) => item.id)])
        })
    }

    let working = $state(false)

    async function activateSelected(oneYear: boolean = false) {
        working = true

        const data: any = {
            partial_activation: [],
        }
        if (!$order.finalized) {
            for (const item of $items) {
                if (!$selectedItems.has(item.id)) continue
                if (oneYear && (item.type == 'DOMAIN' || item.type == 'RENEWAL')) {
                    data['partial_activation'].push([item.type, item.id, 1])
                } else {
                    data['partial_activation'].push([item.type, item.id])
                }
            }
        }

        let r: SimpleFetchResult
        try {
            r = await simpleFetch('POST', `/json/ecom/1/order/${$orderId}/activate-cart-items`, data)
        } catch (e: any) {
            r = e
            console.error('Failed to activate items:', e)
            notify({
                type: 'danger',
                title: 'Commande',
                text: 'Les items sélectionnés n’ont pas pu être activé' + (e && e.data && e.data.error ? ` : ${e.data.error}` : '.'),
            })
        }

        if (r && r.data) {
            Order.loadGenericResponse(r.data)
            selectedItems.update((selecteds) => {
                for (const item of $items) {
                    if (selecteds.has(item.id) && item.finalized) selecteds.delete(item.id)
                }
                return selecteds
            })
        }
        working = false
    }
</script>

<div class="card">
    <div class="card-title text-primary">Activation</div>
    <div class="card-body">
        {#if working}
            <p><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Un moment…</p>
        {:else}
            <p>
                <span class="btn-group">
                    <button type="button" class="btn btn-outline-secondary" disabled>Sélectionner :</button>
                    <button type="button" class="btn btn-outline-secondary" disabled={$allSelected} onclick={() => selectAll()}>tout</button>
                    <button type="button" class="btn btn-outline-secondary" disabled={$allDomainsSelected} onclick={() => selectAllDomains()}>domaines</button>
                    <button type="button" class="btn btn-outline-secondary" disabled={$noneSelected} onclick={() => deselectAll()}>rien</button>
                </span>
            </p>

            <p>
                <button type="button" class="btn btn-warning" disabled={$noneSelected} onclick={() => activateSelected(false)}>Activer les items sélectionnés</button>
                <button type="button" class="btn btn-warning" disabled={$noneSelected || !$onlyDomainsSelected} onclick={() => activateSelected(true)}>Activer 1 an sur les domaines sélectionnés</button>
            </p>
        {/if}
    </div>
</div>
